import { createRequestTypes } from '../utils';

export const FETCH_COSANNEXES = createRequestTypes('cosAnnexe/FETCH_COSANNEXES');
export const DELETE_COSANNEXE = createRequestTypes('cosAnnexe/DELETE_COSANNEXE');
export const SAVE_COSANNEXE = createRequestTypes('cosAnnexe/SAVE_COSANNEXE');
